import React from 'react';
import { useTranslation } from 'react-i18next';
import { LANGUAGE_LABELS } from '../utils/language';
import './LanguageModal.css';

const LanguageModal = ({ isOpen, onClose, onSelect, currentLang }) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content language-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="header-title">
            <div className="globe-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#E46C25" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="2" y1="12" x2="22" y2="12"></line>
                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
              </svg>
            </div>
            <div className="title-text">
              <h2>{t('languageModal.chooseLanguage', 'Choose Language')}</h2>
              <p>{t('languageModal.chooseLanguageHi', 'भाषा चुनें')}</p>
            </div>
          </div>
          <button className="close-btn" onClick={onClose}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <div className="header-divider"></div>

        <div className="modal-body">
          <div className={`language-option ${currentLang === 'en' ? 'selected' : ''}`} onClick={() => { onSelect('English'); onClose(); }}>
            <div className="option-info">
              <h3>English</h3>
              <p>{t('languageModal.continueInEn', 'Continue in English')}</p>
            </div>
            <div className="flag-icon uk-flag">
              <img src="https://upload.wikimedia.org/wikipedia/en/a/ae/Flag_of_the_United_Kingdom.svg" alt="UK Flag" />
            </div>
          </div>

          <div className={`language-option ${currentLang === 'hi' ? 'selected' : ''}`} onClick={() => { onSelect('Hindi'); onClose(); }}>
            <div className="option-info">
              <h3>{LANGUAGE_LABELS.hi}</h3>
              <p>{t('languageModal.continueInHi', 'हिंदी में जारी रखें')}</p>
            </div>
            <div className="flag-icon india-flag">
              <img src="https://upload.wikimedia.org/wikipedia/en/4/41/Flag_of_India.svg" alt="India Flag" />
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <p>{t('languageModal.changeAnytime', 'You can change language anytime from the top menu')}</p>
        </div>
      </div>
    </div>
  );
};

export default LanguageModal;


